import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  authorize_by_uuid($, uuid, guestUsername) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/inspections/${uuid}/video`, {
        username: guestUsername
      })
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  recording($, id, action, username = null) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/inspections/${id}/video/recording/${action}`, {
        username: username
      })
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getRecordings($, id, action) {
    return new Promise((resolve, reject) => {
      HTTP.get(`projects/inspections/${id}/video/recordings`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  downloadRecord($, id, sid) {
    return new Promise((resolve, reject) => {
      const path = `${BACKEND_API_URL}/projects/inspections/${id}/video/recordings/${sid}`
      let xhr = new XMLHttpRequest()
      xhr.open("GET", path, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.responseType = "arraybuffer"
      xhr.onload = function (e) {
        let blob = new Blob([xhr.response], { type: "video/webm" })
        let link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = sid + ".mkv"
        link.click()
      }
      xhr.send()
    })
  },
  removeRecord($, id, sid) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`projects/inspections/${id}/video/recordings/${sid}`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  removeRecordByUrl(url) {
    return new Promise((resolve, reject) => {
      HTTP.delete(url)
        .then(response => resolve(response.data))
        .catch(err => {
          reject(err)
        })
    })
  }
}
